export default __webpack_public_path__ + "static/media/pikachu.a4f7f86b.gif";